export const FETCH_QUESTIONS_INIT = "FETCH_QUESTIONS_INIT";
export const FETCH_QUESTIONS_INPROGRESS = "FETCH_QUESTIONS_INPROGRESS";
export const FETCH_QUESTIONS_SUCCESS = "FETCH_QUESTIONS_SUCCESS";
export const FETCH_QUESTIONS_FAILED = "FETCH_QUESTIONS_FAILED";
export const QUESTIONS_CLEAR_ERROR = "QUESTIONS_CLEAR_ERROR";
